{
  "version": 1,
  "asset_id": "787a1edf-a11f-465e-9ad2-7b41a73d8d44",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/787a1edf-a11f-465e-9ad2-7b41a73d8d44/bypass-revision-completed-pouch-en-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/787a1edf-a11f-465e-9ad2-7b41a73d8d44/bypass-revision-completed-pouch-en-640.webp",
  "original_filename": "bypass-revision-completed-pouch-en-640.webp",
  "size": 27086,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:12:52Z"
}
